import FilterableCell, { getRefId } from '@/widgets/FilterableCell'

export default function WojewodztwaTableRow({ wojewodztwo, onNazwaClick }) {
	const wojewodztwoId = getRefId(wojewodztwo)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={wojewodztwoId}
					label={wojewodztwo?.nazwa || '-'}
					onFilter={onNazwaClick}
				/>
			</td>
		</tr>
	)
}
